<template>
    <div>
        <base-crud
                crudName="Motivos de Ausência"
                newText="Novo Motivo de Ausência"
                :table="absenceReasonTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                absenceReasonTable: 'absenceReasonTable',
                absenceReasons: [],
                pages: [],
                url: '',
                columns: ['id','name', 'actions'],
                tableData: ['id','name'],
                options: {
                    filterable:["id", "name"],
                    filterByColumn: true,                   
                    sortable: ['id', 'name'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': 'ID',
                        'name' : 'Nome',
                        'actions' : 'Ações'
                    },
                    templates: {},
                    requestFunction: function(data) {
                      let requestData = {};

                       let query = this.$parent.$parent.query(data.query);
                       requestData.params = data;
                       requestData.params.query = "";
                       requestData.params.with = [];

                      return this.$http
                          .get(this.url + '?' + query, requestData)
                          .catch(
                              function(e) {
                                  this.dispatch("error", e);
                              }.bind(this)
                          );
                    },
                },
                endPoint: 'absence-reasons/'
            }
        },
        methods: {
          query: function (query) {
            let columns = {
              id: 'id',
              name: 'name',
            };
            let filters = "";
            $.each(query, function (index, value) {
              filters += columns[index] + "=" + value + "&";
            });
    
               return filters;
          }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/AbsenceReason/Crud.vue